import React, { useEffect, useState, useMemo, useContext } from "react";
import {
  Modal,
  Checkbox,
  Input,
  Divider,
  Button,
  Tooltip,
  Row,
  Col,
} from "antd";
import _ from "lodash";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import defaultLogo from "../../assets/images/default_company_logo.jpg";
import {
  ArrowLeft,
  Info,
  FileText,
  Tag as TagIcon,
  Building2,
  Users,
  Phone,
  Mail,
  Globe,
  MapPin,
} from "lucide-react";
import {
  submitErrorForm,
  createCompanyTag,
  emptyErrorObj,
  getCompanyTag,
  resetCreatedTag,
  resetCompanyTag,
} from "../../actionCreator/companyDetailsActionCreator";
import { emailRegex } from "../../config";
import {
  getSubscriptionUserInfo,
  getUserInfo,
  getPartialPhoneNumber,
} from "../../utils/utils";
import { getCompanyLogoUrl } from "../../utils";
import TrialModal from "../../common/TrialModal";
import ViewEmailPhoneModal from "../../common/ViewEmailPhoneModal";
import { AuthContext } from "../../context/AuthContext";

const SummaryHeader = ({ downloadPDFCallback }) => {
  const [showModal, setShowModal] = useState(false);
  const [openModal, setOpenModal] = useState({
    info: null,
    open: false,
  });
  const [showEmailPhoneModal, setShowEmailPhoneModal] = useState(false);
  const formIntialValue = {
    telephone: { disabled: true, value: "", status: null },
    address: { disabled: true, value: "", status: null },
    city: { disabled: true, value: "", status: null },
    zip: { disabled: true, value: "", status: null },
    employee: { disabled: true, value: "", status: null },
    website: { disabled: true, value: "", status: null },
    name: { disabled: true, value: "", status: null },
    email: { disabled: true, value: "", status: null },
    comment: { disabled: true, value: "", status: null },
  };

  const dispatch = useDispatch();
  const { isAuthenticated } = useContext(AuthContext);
  const { TextArea } = Input;
  const [openErrorForm, setOpenErrorForm] = useState(false);
  const [isApiFailed, setIsApiFailed] = useState(false);
  const [openTagModal, setOpenTagModal] = useState(false);
  const [tagValues, setTagValues] = useState({
    tagname: "",
    description: "",
    tagError: "",
  });
  const [errorForm, setErrorForm] = useState(formIntialValue);
  const companyDetails = useSelector(
    (state) => state.companyDetailsReducer.companyDetails,
  );
  const navigate = useNavigate();
  const errObj = useSelector((state) => state.companyDetailsReducer.errObj);
  const fetchCompanyTag = useSelector(
    (state) => state.companyDetailsReducer.fetchCompanyTag,
  );
  const sigleCompanyTag = useSelector(
    (state) => state.companyDetailsReducer.sigleCompanyTag,
  );

  const userAccountInfo = useSelector(
    (state) => state.CommonReducer.accountInfo,
  );

  const [taggedCompany, setTaggedCompany] = useState(false);
  const [taggedCompanySuccess, setTaggedCompanySuccess] = useState(false);
  useEffect(() => {
    if (Object.keys(errObj).length) {
      setIsApiFailed(true);
    }
    if (!Object.keys(errObj).length) {
      setIsApiFailed(false);
    }
  }, [Object.keys(errObj).length]);

  useMemo(() => {
    if (Object.keys(getUserInfo()).length && companyDetails?.id) {
      const { id } = getUserInfo();
      dispatch(resetCompanyTag());
      dispatch(getCompanyTag(companyDetails?.id, id));
    }
  }, [companyDetails, userAccountInfo]);

  useEffect(() => {
    if (fetchCompanyTag.length) {
      setTaggedCompany(true);
    } else {
      setTaggedCompany(false);
    }
  }, [fetchCompanyTag]);

  useEffect(() => {
    if (Object.keys(sigleCompanyTag).length) {
      setTaggedCompanySuccess(true);
    }
  }, [sigleCompanyTag]);

  const closeErrorForm = () => {
    setOpenErrorForm(false);
    setErrorForm(formIntialValue);
  };

  const enableField = (ele) => {
    setErrorForm({
      ...errorForm,
      [ele.target.name]: ele.target.checked
        ? { ...errorForm[ele.target.name], disabled: !ele.target.checked }
        : { value: "", disabled: !ele.target.checked },
    });
  };

  const onInputChange = (ele) => {
    setErrorForm({
      ...errorForm,
      [ele.target.name]: {
        ...errorForm[ele.target.name],
        value: ele.target.value,
        status: null,
      },
    });
  };

  const onSubmitForm = () => {
    const regEx = new RegExp(emailRegex);
    const clone = _.cloneDeep(errorForm);
    if (!errorForm?.name?.value) {
      clone.name.status = "error";
      setErrorForm(clone);
      return false;
    }

    if (!errorForm?.email?.value || !regEx.test(errorForm?.email?.value)) {
      clone.email.status = "error";
      setErrorForm(clone);
      return false;
    }

    let newPayload = {};
    Object.keys(errorForm).forEach((key) => {
      newPayload = {
        ...newPayload,
        [key]: errorForm[key].value,
      };
    });
    const { id } = getUserInfo();
    const { id: accountId } = getSubscriptionUserInfo();
    const payload = {
      accountId: accountId,
      companyId: companyDetails?.id,
      description: newPayload,
      iscompany: true,
      iscorrected: true,
      userId: id,
    };
    dispatch(submitErrorForm(payload));
    setOpenErrorForm(false);
    setErrorForm(formIntialValue);
  };

  const checkLoginStatus = () => {
    let isLoggedIn = false;
    if (isAuthenticated) {
      setShowModal(false);
      isLoggedIn = true;
    } else {
      setShowEmailPhoneModal(true);
      isLoggedIn = false;
    }
    return isLoggedIn;
  };

  const onConfrim = () => {
    if (!tagValues.tagname) {
      setTagValues({
        ...tagValues,
        tagError: "error",
      });
    } else {
      const { id } = getUserInfo();
      const payload = {
        company: companyDetails,
        text: tagValues.tagname,
        userId: id,
      };
      dispatch(createCompanyTag(payload));
      setOpenTagModal(false);
    }
  };

  const onTagInputChange = (e) => {
    setTagValues({
      ...tagValues,
      [e.target.name]: e.target.value,
    });
  };

  const tagCompany = () => {
    const isLoggedIn = checkLoginStatus();
    if (isLoggedIn) {
      setOpenTagModal(true);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setOpenModal(false);
    dispatch(emptyErrorObj());
  };

  const redirectToSignup = () => {
    setShowModal(false);
    navigate("/signup");
  };

  const closeTagModal = () => {
    setOpenTagModal(false);
  };
  const closeCompanySuccessModal = () => {
    setTaggedCompanySuccess(false);
    dispatch(resetCreatedTag());
  };

  return (
    <div className="navbar-light tw-text-text-primary tw-font-inter mrgn mt-4" id="onScroll">
      <div className="tw-bg-white tw-border tw-border-solid tw-border-slate-200/80 tw-rounded-2xl tw-p-5 tw-mb-6 tw-shadow-sm">
        <div className="tw-flex tw-flex-col lg:tw-flex-row lg:tw-items-center lg:tw-justify-between tw-gap-5">
          <div className="tw-flex tw-items-center tw-gap-4 tw-flex-1 tw-min-w-0">
            {/* Back Button */}
            <div
              className="tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-size-10 tw-rounded-xl tw-border tw-border-solid tw-border-slate-200 hover:tw-border-theme/35 hover:tw-bg-indigo-50/20 tw-text-slate-500 hover:tw-text-theme tw-transition-all tw-shrink-0"
              onClick={() => navigate(-1)}
            >
              <ArrowLeft size={18} />
            </div>

            {/* Logo */}
            <div className="tw-size-16 tw-rounded-2xl tw-overflow-hidden tw-border tw-border-solid tw-border-slate-200 tw-shrink-0 tw-shadow-sm tw-bg-secondary-color tw-flex tw-items-center tw-justify-center">
              {companyDetails?.companyLogoUrl ? (
                <img
                  src={getCompanyLogoUrl(companyDetails?.companyLogoUrl)}
                  alt="Company logo"
                  className="tw-w-full tw-h-full tw-object-contain"
                  onError={(e) => {
                    e.currentTarget.src = defaultLogo;
                  }}
                />
              ) : (
                <img src={defaultLogo} alt="Company logo" className="tw-w-full tw-h-full tw-object-contain" />
              )}
            </div>

            {/* Title / Name & Address */}
            <div className="tw-flex-1 tw-min-w-0">
              {!!companyDetails?.name && (
                <h2 className="tw-text-xl tw-font-bold tw-text-slate-800 tw-m-0">
                  {companyDetails?.name}
                </h2>
              )}
              {!!companyDetails?.address && (
                <div className="tw-text-slate-400 tw-text-xs tw-font-medium tw-flex tw-items-center tw-gap-1.5 tw-mt-1.5">
                  <MapPin size={14} className="tw-text-slate-400 tw-shrink-0" />
                  <span>
                    {companyDetails?.address?.endsWith(".")
                      ? companyDetails?.address?.slice(0, -1)
                      : companyDetails?.address}
                    , {companyDetails?.city}, {companyDetails?.state},{" "}
                    {companyDetails?.country}
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* Action Chips */}
          <div className="tw-flex tw-items-center tw-gap-2.5 tw-shrink-0">
            {!isAuthenticated && (
              <button
                type="button"
                onClick={() => setShowEmailPhoneModal(true)}
                className="tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-px-4 tw-h-10 tw-bg-transparent hover:tw-bg-indigo-50/50 tw-text-[#5D44FF] hover:tw-text-indigo-600 tw-font-bold tw-text-sm tw-rounded-xl tw-border tw-border-solid tw-border-[#5D44FF] hover:tw-border-indigo-600 tw-transition-all hover:tw-scale-[1.02] tw-outline-none tw-cursor-pointer tw-whitespace-nowrap"
              >
                <Mail size={16} />
                <span>View Email and Phone</span>
              </button>
            )}
            <Tooltip title="Tag Company">
              <div
                className="tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-size-10 tw-rounded-xl tw-border tw-border-solid tw-border-slate-200 hover:tw-border-theme/35 hover:tw-bg-indigo-50/20 tw-text-slate-500 hover:tw-text-theme tw-transition-all tw-shrink-0"
                onClick={tagCompany}
              >
                <TagIcon size={18} />
              </div>
            </Tooltip>

            <Tooltip title="Download PDF">
              <div
                className="tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-size-10 tw-rounded-xl tw-border tw-border-solid tw-border-slate-200 hover:tw-border-rose-100 hover:tw-bg-rose-50/20 tw-text-rose-500 tw-transition-all tw-shrink-0"
                onClick={() => {
                  if (isAuthenticated) {
                    downloadPDFCallback(companyDetails?.id);
                  } else {
                    setShowEmailPhoneModal(true);
                  }
                }}
              >
                <FileText size={18} />
              </div>
            </Tooltip>
          </div>
        </div>

        {/* Metadata Row */}
        <div className="tw-bg-slate-50/40 tw-border tw-border-solid tw-border-slate-100 tw-rounded-xl tw-p-5 tw-mt-5">
          <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-12 tw-gap-y-6 tw-text-sm">
            {!!companyDetails?.industry?.name && (
              <div className="tw-flex tw-items-center tw-gap-2.5 tw-min-w-[160px]">
                <div className="tw-size-9 tw-bg-white tw-border tw-border-solid tw-border-slate-200/60 tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-shrink-0">
                  <Building2 size={16} className="tw-text-slate-500" />
                </div>
                <div className="tw-flex tw-flex-col">
                  <span className="tw-text-[10px] tw-text-slate-400 tw-font-bold tw-uppercase tw-tracking-wider">Industry</span>
                  <span className="tw-text-xs tw-font-bold tw-text-slate-700 tw-mt-0.5">
                    {companyDetails?.industry?.name}
                  </span>
                </div>
              </div>
            )}
            {!!companyDetails?.range?.name && (
              <div className="tw-flex tw-items-center tw-gap-2.5 tw-min-w-[160px]">
                <div className="tw-size-9 tw-bg-white tw-border tw-border-solid tw-border-slate-200/60 tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-shrink-0">
                  <Users size={16} className="tw-text-slate-500" />
                </div>
                <div className="tw-flex tw-flex-col">
                  <span className="tw-text-[10px] tw-text-slate-400 tw-font-bold tw-uppercase tw-tracking-wider">Employee count</span>
                  <span className="tw-text-xs tw-font-bold tw-text-slate-700 tw-mt-0.5">
                    {companyDetails?.range?.name}
                  </span>
                </div>
              </div>
            )}
            {!!companyDetails?.phoneNo && (
              <div
                className={`tw-flex tw-items-center tw-gap-2.5 ${!isAuthenticated ? "tw-cursor-pointer" : ""}`}
                onClick={!isAuthenticated ? () => setShowEmailPhoneModal(true) : undefined}
              >
                <div className="tw-size-9 tw-bg-white tw-border tw-border-solid tw-border-slate-200/60 tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-shrink-0">
                  <Phone size={16} className="tw-text-slate-500" />
                </div>
                <div className="tw-flex tw-flex-col">
                  <span className="tw-text-[10px] tw-text-slate-400 tw-font-bold tw-uppercase tw-tracking-wider">Phone</span>
                  <Tooltip title={!isAuthenticated ? "Click to view phone - Contact Us" : getPartialPhoneNumber(companyDetails?.phoneNo)}>
                    <span className="tw-text-xs tw-font-bold tw-text-slate-700 tw-mt-0.5 tw-whitespace-nowrap tw-cursor-pointer hover:tw-text-theme">
                      {(() => {
                        const rawPhone = getPartialPhoneNumber(companyDetails?.phoneNo);
                        if (rawPhone && rawPhone.includes("/")) {
                          return rawPhone.split("/")[0].trim() + "...";
                        }
                        return rawPhone;
                      })()}
                    </span>
                  </Tooltip>
                </div>
              </div>
            )}
            {!!companyDetails?.wedsite && (
              <div className="tw-flex tw-items-center tw-gap-2.5 tw-min-w-[120px] tw-max-w-[200px]">
                <div className="tw-size-9 tw-bg-white tw-border tw-border-solid tw-border-slate-200/60 tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-shrink-0">
                  <Globe size={16} className="tw-text-slate-500" />
                </div>
                <div className="tw-flex tw-flex-col tw-min-w-0 tw-flex-1">
                  <span className="tw-text-[10px] tw-text-slate-400 tw-font-bold tw-uppercase tw-tracking-wider">Website</span>
                  <Tooltip title={companyDetails?.wedsite}>
                    <a
                      className="tw-text-xs tw-font-bold tw-text-slate-700 tw-mt-0.5 hover:tw-text-theme tw-truncate tw-underline"
                      href={companyDetails?.wedsite?.startsWith("http") ? companyDetails.wedsite : `http://${companyDetails?.wedsite}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {companyDetails?.wedsite}
                    </a>
                  </Tooltip>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <ViewEmailPhoneModal
        open={showEmailPhoneModal}
        onClose={() => setShowEmailPhoneModal(false)}
      />
      {openErrorForm && (
        <Modal
          title={
            <div className="tw-flex tw-flex-col tw-gap-0.5">
              <span className="tw-text-xs tw-font-bold tw-text-theme tw-uppercase tw-tracking-wider">
                Report an Error
              </span>
              <span className="tw-text-base tw-font-bold tw-text-slate-800">
                Report Incorrect Information
              </span>
            </div>
          }
          width="480px"
          closable
          centered
          open={openErrorForm}
          onCancel={closeErrorForm}
          footer={[
            <Button
              key="cancel"
              onClick={closeErrorForm}
              className="tw-border-slate-200 hover:tw-border-slate-300 tw-text-slate-600 hover:tw-text-slate-800 tw-text-xs tw-font-bold tw-h-10 tw-rounded-xl tw-px-5"
            >
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={onSubmitForm}
              className="!tw-bg-theme hover:!tw-bg-theme/90 !tw-border-theme tw-text-white tw-text-xs tw-font-bold tw-h-10 tw-rounded-xl tw-px-6"
            >
              Submit
            </Button>,
          ]}
        >
          <div className="tw-mt-4 tw-flex tw-flex-col tw-gap-3.5 tw-font-inter">
            <p className="tw-text-xs tw-font-medium tw-text-slate-500 tw-leading-relaxed tw-mb-1">
              Please select the appropriate checkbox that you have found
              Incorrect and if you know the correct data please provide us in
              appropriate text box.
            </p>

            {/* Telephone */}
            <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
              <div className="tw-w-[140px] tw-shrink-0">
                <Checkbox name="telephone" onChange={enableField} className="tw-text-xs tw-font-bold tw-text-slate-700">
                  Telephone
                </Checkbox>
              </div>
              <div className="tw-flex-1">
                <Input
                  name="telephone"
                  value={errorForm?.telephone?.value}
                  placeholder="Telephone"
                  disabled={errorForm?.telephone?.disabled}
                  onChange={onInputChange}
                  className="tw-h-10 tw-rounded-xl tw-border tw-border-solid tw-border-slate-200 focus:tw-border-theme disabled:tw-bg-slate-50/70 disabled:tw-text-slate-400 tw-px-3"
                />
              </div>
            </div>

            {/* Address */}
            <div className="tw-flex tw-items-start tw-justify-between tw-gap-4">
              <div className="tw-w-[140px] tw-shrink-0 tw-mt-2">
                <Checkbox name="address" onChange={enableField} className="tw-text-xs tw-font-bold tw-text-slate-700">
                  Address
                </Checkbox>
              </div>
              <div className="tw-flex-1">
                <TextArea
                  name="address"
                  value={errorForm?.address?.value}
                  rows={2}
                  maxLength={100}
                  disabled={errorForm?.address?.disabled}
                  onChange={onInputChange}
                  placeholder="Address"
                  className="tw-rounded-xl tw-border tw-border-solid tw-border-slate-200 focus:tw-border-theme disabled:tw-bg-slate-50/70 disabled:tw-text-slate-400 tw-p-2.5"
                />
              </div>
            </div>

            {/* City */}
            <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
              <div className="tw-w-[140px] tw-shrink-0">
                <Checkbox name="city" onChange={enableField} className="tw-text-xs tw-font-bold tw-text-slate-700">
                  City
                </Checkbox>
              </div>
              <div className="tw-flex-1">
                <Input
                  name="city"
                  value={errorForm?.city?.value}
                  placeholder="City"
                  disabled={errorForm?.city?.disabled}
                  onChange={onInputChange}
                  className="tw-h-10 tw-rounded-xl tw-border tw-border-solid tw-border-slate-200 focus:tw-border-theme disabled:tw-bg-slate-50/70 disabled:tw-text-slate-400 tw-px-3"
                />
              </div>
            </div>

            {/* Zip */}
            <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
              <div className="tw-w-[140px] tw-shrink-0">
                <Checkbox name="zip" onChange={enableField} className="tw-text-xs tw-font-bold tw-text-slate-700">
                  Zip/Pin code
                </Checkbox>
              </div>
              <div className="tw-flex-1">
                <Input
                  name="zip"
                  value={errorForm?.zip?.value}
                  placeholder="Zip/Pin code"
                  disabled={errorForm?.zip?.disabled}
                  onChange={onInputChange}
                  className="tw-h-10 tw-rounded-xl tw-border tw-border-solid tw-border-slate-200 focus:tw-border-theme disabled:tw-bg-slate-50/70 disabled:tw-text-slate-400 tw-px-3"
                />
              </div>
            </div>

            {/* Employee */}
            <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
              <div className="tw-w-[140px] tw-shrink-0">
                <Checkbox name="employee" onChange={enableField} className="tw-text-xs tw-font-bold tw-text-slate-700">
                  No. of Employees
                </Checkbox>
              </div>
              <div className="tw-flex-1">
                <Input
                  name="employee"
                  value={errorForm?.employee?.value}
                  placeholder="No. of Employees"
                  disabled={errorForm?.employee?.disabled}
                  onChange={onInputChange}
                  className="tw-h-10 tw-rounded-xl tw-border tw-border-solid tw-border-slate-200 focus:tw-border-theme disabled:tw-bg-slate-50/70 disabled:tw-text-slate-400 tw-px-3"
                />
              </div>
            </div>

            {/* Website */}
            <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
              <div className="tw-w-[140px] tw-shrink-0">
                <Checkbox name="website" onChange={enableField} className="tw-text-xs tw-font-bold tw-text-slate-700">
                  Website
                </Checkbox>
              </div>
              <div className="tw-flex-1">
                <Input
                  name="website"
                  value={errorForm?.website?.value}
                  placeholder="Website"
                  disabled={errorForm?.website?.disabled}
                  onChange={onInputChange}
                  className="tw-h-10 tw-rounded-xl tw-border tw-border-solid tw-border-slate-200 focus:tw-border-theme disabled:tw-bg-slate-50/70 disabled:tw-text-slate-400 tw-px-3"
                />
              </div>
            </div>

            <Divider dashed={true} className="tw-my-1" />

            {/* Name */}
            <div>
              <Input
                name="name"
                status={errorForm?.name?.status}
                value={errorForm?.name?.value}
                placeholder="Your Name*"
                onChange={onInputChange}
                className="tw-h-10 tw-rounded-xl tw-border tw-border-solid tw-border-slate-200 focus:tw-border-theme tw-px-3"
              />
            </div>

            {/* Email */}
            <div>
              <Input
                name="email"
                status={errorForm?.email?.status}
                value={errorForm?.email?.value}
                placeholder="Your Email ID*"
                onChange={onInputChange}
                className="tw-h-10 tw-rounded-xl tw-border tw-border-solid tw-border-slate-200 focus:tw-border-theme tw-px-3"
              />
            </div>

            {/* Comment */}
            <div>
              <TextArea
                name="comment"
                value={errorForm?.comment?.value}
                rows={3}
                maxLength={100}
                placeholder="Comment if any"
                onChange={onInputChange}
                className="tw-rounded-xl tw-border tw-border-solid tw-border-slate-200 focus:tw-border-theme tw-p-2.5"
              />
            </div>
          </div>
        </Modal>
      )}

      {showModal ? (
        <TrialModal
          openModal={showModal}
          closeModal={closeModal}
          redirectToSignup={redirectToSignup}
          redirect={true}
        />
      ) : (
        ""
      )}
      {openModal?.open && (
        <TrialModal
          openModal={openModal}
          closeModal={closeModal}
          redirectToSignup={redirectToSignup}
          redirect={true}
          isSubscriptionMissing
        />
      )}

      {isApiFailed ? (
        <TrialModal
          openModal={isApiFailed}
          closeModal={closeModal}
          redirectToSignup={redirectToSignup}
          buttonText="OK"
          modalBody={
            <div id="small-dialog2">
              Please call System support. You application having some issue.
            </div>
          }
          modalWidth="400px"
        />
      ) : (
        ""
      )}

      {taggedCompanySuccess ? (
        <Modal
          title=""
          width={"400px"}
          closable={true}
          open={taggedCompanySuccess}
          footer={[
            <Button
              key="submit"
              type="primary"
              onClick={closeCompanySuccessModal}
            >
              OK
            </Button>,
          ]}
        >
          <div className="pop-up errorformcontainer ">
            <p>Tag created!</p>
          </div>
        </Modal>
      ) : (
        ""
      )}

      {openTagModal && (
        <Modal
          title={
            <span className="tw-text-base tw-font-bold tw-text-slate-800">
              Tag Company
            </span>
          }
          width="400px"
          closable
          centered
          open={openTagModal}
          onCancel={closeTagModal}
          footer={[
            <Button
              key="cancel"
              onClick={closeTagModal}
              className="tw-border-slate-200 hover:tw-border-slate-300 tw-text-slate-600 hover:tw-text-slate-800 tw-text-xs tw-font-bold tw-h-10 tw-rounded-xl tw-px-5"
            >
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={onConfrim}
              className="!tw-bg-theme hover:!tw-bg-theme/90 !tw-border-theme tw-text-white tw-text-xs tw-font-bold tw-h-10 tw-rounded-xl tw-px-6"
            >
              Tag Company
            </Button>,
          ]}
        >
          <div className="tw-mt-4 tw-flex tw-flex-col tw-gap-4 tw-font-inter">
            {taggedCompany && (
              <div className="tw-bg-amber-50 tw-border tw-border-solid tw-border-amber-100 tw-rounded-xl tw-p-3.5 tw-flex tw-items-center tw-gap-2.5">
                <Info size={18} className="tw-text-amber-500 tw-shrink-0" />
                <span className="tw-text-xs tw-font-semibold tw-text-amber-800">
                  Already Tagged!
                </span>
              </div>
            )}
            <div className="tw-flex tw-flex-col tw-gap-2">
              <span className="tw-text-[13px] tw-font-bold tw-text-slate-700">
                Tag Name <span className="tw-text-red-500 tw-ml-0.5">*</span>
              </span>
              <Input
                name="tagname"
                status={tagValues?.tagError}
                value={tagValues.tagname}
                placeholder="Enter tag name"
                onChange={onTagInputChange}
                className="tw-h-10 tw-rounded-xl tw-border tw-border-solid tw-border-slate-200 focus:tw-border-theme focus:tw-ring-1 focus:tw-ring-theme tw-px-3"
              />
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default SummaryHeader;
